import * as React from 'react';
import { Box } from '@mui/material';

interface CerebroPageContainerProps {
	maxWidth?: string | null;
	children: React.ReactNode;
}

export const CerebroPageContainer: React.FC<CerebroPageContainerProps> = ({ maxWidth, children }) => {
	const leftPadding = { xs: 2, sm: 2, md: 4, lg: 6, xl: 15 };
	const rightPadding = { xs: 2, sm: 2, md: 2, lg: 4, xl: 6 };

	return (
		<Box
			sx={{
				paddingLeft: leftPadding,
				paddingTop: { xs: 8, md: 3 },
				paddingRight: rightPadding,
				paddingBottom: 12,
				maxWidth: maxWidth || '1080px',
			}}
		>
			{children}
		</Box>
	);
};
